import React, { useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";
import NtModal from "../../components/NtModal";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import NtBadge from "../../components/NtBadge";
import NtVoicemailUpdateForm from "./NtVoicemailUpdateForm";
import { usePermission } from "../../hooks/usePermission";
import routes from "../../navigation/routes";
import settings from "../../config/settings";

function NtVoicemailItemItem({ item, columns, onPress, onUpdate, onDelete }) {
  const updateModalRef = useRef();
  const permission = usePermission(
    settings.permissionTypeEdit,
    routes.voicemail
  );

  const renderUpdateForm = () => {
    return (
      <NtModal ref={updateModalRef}>
        <NtVoicemailUpdateForm
          item={item}
          onCancel={() => {
            updateModalRef.current?.dismiss();
          }}
          onUpdate={() => {
            updateModalRef.current?.dismiss();
            if (onUpdate) {
              onUpdate();
            }
          }}
          onDelete={() => {
            updateModalRef.current?.dismiss();
            if (onDelete) {
              onDelete();
            }
          }}
        />
      </NtModal>
    );
  };

  return (
    <View style={styles.container}>
      <NtTouchableEffect onPress={onPress}>
        <NtListRow
          item={item}
          columns={columns}
          renderCustom={(item, column) => {
            if (column == "voicemail_enabled") {
              const enabled = item[column] == "true";
              return (
                <NtBadge variant={enabled ? "green" : "gray"}>
                  {enabled ? "Enabled" : "Disabled"}
                </NtBadge>
              );
            } else if (column == "messages") {
              const unread = item[column]?.unread || 0;
              const read = item[column]?.read || 0;
              return (
                <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
                  <NtBadge variant={unread > 0 ? "blue" : "gray"}>
                    {unread} unread
                  </NtBadge>
                  <NtBadge variant="gray" dot={false}>
                    {read} read
                  </NtBadge>
                </View>
              );
            }
          }}
          onActionPress={
            permission
              ? () => {
                  updateModalRef.current?.show();
                }
              : null
          }
        />
      </NtTouchableEffect>
      {/* Modal rendered as a sibling, not a child of the row's TouchableEffect.
          Otherwise clicks inside the modal bubble up to the row's onPress and
          immediately close the modal. */}
      {renderUpdateForm()}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtVoicemailItemItem;
